import * as React from 'react';

export const LoadingCircle = props => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4176 21.3711H10.4076C9.8556 21.3711 9.4126 21.8181 9.4126 22.3711C9.4126 22.9241 9.8656 23.3711 10.4176 23.3711C10.9696 23.3711 11.4176 22.9241 11.4176 22.3711C11.4176 21.8181 10.9696 21.3711 10.4176 21.3711Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.598 21.1425C15.134 20.8415 14.515 20.9735 14.215 21.4365L14.208 21.4465C13.907 21.9095 14.042 22.5235 14.505 22.8255C14.672 22.9335 14.86 22.9855 15.046 22.9855C15.375 22.9855 15.699 22.8225 15.891 22.5265C16.193 22.0635 16.061 21.4445 15.598 21.1425Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26309 19.1579C5.77809 18.8899 5.16709 19.0769 4.90309 19.5619C4.63809 20.0469 4.81709 20.6539 5.30209 20.9189C5.45409 21.0019 5.61809 21.0409 5.78009 21.0409C6.13409 21.0409 6.47709 20.8519 6.65909 20.5189L6.66509 20.5089C6.93009 20.0239 6.74809 19.4219 6.26309 19.1579Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4266 18.4928C18.9526 18.2088 18.3386 18.3618 18.0546 18.8358L18.0486 18.8458C17.7646 19.3188 17.9206 19.9288 18.3946 20.2128C18.5546 20.3078 18.7306 20.3538 18.9046 20.3538C19.2466 20.3538 19.5816 20.1788 19.7696 19.8648C20.0536 19.3908 19.9006 18.7768 19.4266 18.4928Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.82248 5.24209L9.82748 5.23209C10.0945 4.74909 9.91548 4.14509 9.43048 3.88009C8.94848 3.61309 8.33748 3.79509 8.07048 4.27909C7.80348 4.76309 7.98048 5.37109 8.46448 5.63709C8.61748 5.72109 8.78248 5.76109 8.94548 5.76109C9.29848 5.76109 9.64048 5.57309 9.82248 5.24209Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.94509 7.90512L5.95109 7.89512C6.23509 7.42212 6.07909 6.81212 5.60509 6.52812C5.13109 6.24512 4.51409 6.40212 4.23009 6.87612C3.94609 7.34912 4.09909 7.96412 4.57309 8.24812C4.73409 8.34412 4.91109 8.39012 5.08709 8.39012C5.42609 8.39012 5.75809 8.21712 5.94509 7.90512Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0748 7.21556C19.3588 6.74156 19.2058 6.12756 18.7318 5.84356C18.2578 5.55856 17.6428 5.71156 17.3598 6.18656L17.3538 6.19556C17.0698 6.66956 17.2258 7.27856 17.6998 7.56356C17.8598 7.65856 18.0358 7.70456 18.2098 7.70456C18.5518 7.70456 18.8868 7.52856 19.0748 7.21556Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5868 4.37109C14.5868 3.81809 14.1338 3.37109 13.5818 3.37109C13.0298 3.37109 12.5818 3.81809 12.5818 4.37109C12.5818 4.92409 13.0298 5.37109 13.5818 5.37109H13.5918C14.1438 5.37109 14.5868 4.92409 14.5868 4.37109Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7269 11.5343C21.0839 11.5343 21.4309 11.3443 21.6129 11.0093C21.8769 10.5243 21.6989 9.91737 21.2139 9.65237C20.7279 9.38837 20.1219 9.56637 19.8569 10.0524L19.8509 10.0624C19.5859 10.5473 19.7679 11.1493 20.2529 11.4133C20.4039 11.4963 20.5659 11.5343 20.7269 11.5343Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.01868 12.5906C3.38568 12.5906 3.73868 12.3886 3.91468 12.0376L3.91868 12.0286C4.16568 11.5336 3.96368 10.9386 3.46968 10.6916C2.97668 10.4446 2.37268 10.6506 2.12468 11.1436C1.87768 11.6376 2.07868 12.2376 2.57268 12.4856C2.71568 12.5566 2.86868 12.5906 3.01868 12.5906Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.78331 15.3484C3.30831 15.0644 2.69231 15.2224 2.40831 15.6964C2.12431 16.1694 2.27731 16.7844 2.75131 17.0684C2.91231 17.1644 3.08931 17.2104 3.26431 17.2104C3.60431 17.2104 3.93532 17.0374 4.12332 16.7254L4.12931 16.7154C4.41331 16.2424 4.25731 15.6324 3.78331 15.3484Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4952 14.294C21.0213 14.009 20.4073 14.163 20.1233 14.637L20.1172 14.647C19.8332 15.12 19.9892 15.73 20.4632 16.014C20.6232 16.109 20.7992 16.155 20.9732 16.155C21.3152 16.155 21.6502 15.98 21.8382 15.666C22.1222 15.192 21.9692 14.578 21.4952 14.294Z"
      fill="#64748B"
    />
  </svg>
);
export default LoadingCircle;
